import React from "react";
import PropTypes from "prop-types";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";

const FormStep = ({
  step,
  handleFormStep,
  errors,
  handleInputChange,
  handleCheckbox,
  handleRecaptcha,
  fullName,
  email,
  phone,
  jobTitle,
  jobLocation,
  terms,
}) => {
  let currentStep;

  switch (step) {
    case 2:
      currentStep = (
        <Step2
          handleFormStep={handleFormStep}
          handleInputChange={handleInputChange}
          handleCheckbox={handleCheckbox}
          handleRecaptcha={handleRecaptcha}
          jobTitle={jobTitle}
          jobLocation={jobLocation}
          terms={terms}
          errors={errors}
        />
      );
      break;
    case 3:
      currentStep = <Step3 />;
      break;
    default:
      currentStep = (
        <Step1
          handleFormStep={handleFormStep}
          handleInputChange={handleInputChange}
          fullName={fullName}
          email={email}
          phone={phone}
          errors={errors}
        />
      );
      break;
  }
  return currentStep;
};

FormStep.propTypes = {
  step: PropTypes.number.isRequired,
  handleFormStep: PropTypes.func.isRequired,
  handleCheckbox: PropTypes.func.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  errors: PropTypes.shape({}),
};

export default FormStep;
